function NoPosts() {
  return (
    <svg
      width="400"
      height="300"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 400 300"
    >
      <circle cx="200" cy="130" r="100" fill="#f3f4f6" />

      <rect
        x="135"
        y="100"
        width="130"
        height="80"
        fill="#a3bffa"
        rx="5"
        ry="5"
      />
      <rect
        x="140"
        y="85"
        width="120"
        height="20"
        fill="#7f9cf5"
        rx="3"
        ry="3"
      />

      <text
        x="200"
        y="250"
        fontSize="16"
        fontFamily="Arial, sans-serif"
        fill="#4a5568"
        textAnchor="middle"
      >
        No posts uploaded yet!
      </text>
      <text
        x="200"
        y="270"
        fontSize="12"
        fontFamily="Arial, sans-serif"
        fill="#a0aec0"
        textAnchor="middle"
      >
        Start uploading your first post now.
      </text>
    </svg>
  );
}

export default NoPosts;
